/* @flow */
import React from 'react';
import gql from 'graphql-tag';
import {
    DestinationMessage as DestinationMessageComponent,
    destinationMessageFragments
} from '@homeaway/react-urgency-messaging';

import type DestinationMessage from '@homeaway/graphql-traveler-urgency-messaging';

export const fragments = {
    SearchResult: gql`
        fragment DestinationMessageSearchResult on SearchResult {
            destinationMessage(assetVersion: 4) {
                iconTitleText {
                    title
                    message
                    icon
                    messageValueType
                    link {
                        linkText
                        linkHref
                    }
                }
                ...DestinationMessageDestinationMessage
            }
        }
        ${destinationMessageFragments.DestinationMessage}
    `
};

export function Content(destinationMessage: DestinationMessage) {
    return (
        <div data-wdio="DestinationMessage">
            <DestinationMessageComponent
                destinationMessage={destinationMessage}
                size={'l'}
                ariaHidden
                className={'UrgencyDestinationMessage--bordered'}
            />
        </div>
    );
}
